import cssReset from './Theme/cssReset';
import BaseTheme from './Theme/Theme';
export default BaseTheme;
cssReset();
export { baseTheme, labels } from './Theme/Theme';
//# sourceMappingURL=BaseTheme.js.map